import React, {useEffect, useState} from 'react'
import {itemAPI2} from "estimate_list/libs/api2";
import styled,{css} from "styled-components";
import {numberFormat} from "estimate_list/libs/util";
import {useDispatch, useSelector} from "react-redux";
import {setEstimateItems, setSelectOnlyOneServiceAssembleModal} from "estimate_list/libs/action";
import AssemblyComponent from "./serviceAsseblyLayer/assemblyComponent";
import {layerAction, layerConfirm, setServiceItems} from "../../../reducers/service";
import DefaultTwoButtonLayer from "../../layer/defaultTwoButtonLayer";
import PcInstallComponent from "./serviceAsseblyLayer/pcInstallComponent";
import OsInstallComponent from "./serviceAsseblyLayer/osInstallComponent";
import OsBuyComponent from "./serviceAsseblyLayer/osBuyComponent";
import GuideAndPowerSeller from "./guide_powerSeller/guide_powerSeller";
import {getCookie} from "estimate_list/libs/cookie";

const ServiceComponent=()=>{
    const dispatch = useDispatch()
    const allEstimateList = useSelector((state)=>state.estimateAdd.estimateItems)//선택된 견럭 리스트

    const layer = useSelector((state)=>state.service)//윈도우 상품정보
    const serviceItems = useSelector((state)=>state.service.service.items)//윈도우 상품정보
    const [init, setInit]=useState(false)

    const [serviceAssembleCodes, setServiceAssembleCodes]=useState([])//조립 서비스 목록 코드
    const [serviceAsCodes, setServiceAsCodes]=useState([])//조립 as 서비스 목록 코드
    const [serviceInstallCodes, setServiceInstallCodes]=useState([])//pc견적에 있는 os코드

    const [assembleFlag, setAssembleFlag]=useState('')//조립 서비스 유무
    const [osFlag, setOsFlag]=useState('')// 정품 운영체제 오류 메시지
    const [pcInstallFlag, setPcInstallFlag]=useState('')// 운영체제 설치 서비스 유무

    const layerAlert = (msg) => {
        dispatch(
            setSelectOnlyOneServiceAssembleModal({
                isOpen: true,
                text: `<span>${msg}</span>`
            })
        );
    }

    const getServiceCode=(arr)=>{
        return new Set([...arr.map(item => item.itemId)])
    }
    const getServiceASCode=(arr)=>{
        return new Set([...arr.filter(item => item.itemName.includes('A/S')).map(item => item.itemId)])
    }
    const getServiceOsCode=(arr)=>{
        return new Set([...arr[0].items.map(item=>item.itemId)])
    }

    useEffect(() => {
        const {basic, premium, install} = serviceItems
        const assembleCode = [];
        const assembleASCode = [];
        const installCode = [];

        const addServiceCodes = (service, codeArray, asCodeArray) => {
            if (service !== null) {
                codeArray.push(...getServiceCode(service));
                asCodeArray.push(...getServiceASCode(service));
            }
        };
        const addServiceOsCodes = (service, codeArray) => {
            if(service !== null){
                codeArray.push(...getServiceOsCode(service));
            }
        };

        addServiceCodes(basic, assembleCode, assembleASCode);
        addServiceCodes(premium, assembleCode, assembleASCode);
        addServiceOsCodes(install, installCode, []);

        setServiceAssembleCodes(assembleCode);
        setServiceAsCodes(assembleASCode);
        setServiceInstallCodes(installCode);
    }, [serviceItems]);

    const getServiceList = async () => {
        await itemAPI2.getServiceList().then(res=>{
            if(res){
                dispatch(setServiceItems({data: res.data}))
            }
        })
        setInit(true)
    }

    useEffect(() => {
        getServiceList()
    }, []);

    useEffect(() => {
        setAssembleFlag('')
        setOsFlag('')
        setPcInstallFlag('')
        getServiceList()
    }, [allEstimateList]);

    const closeLayer = () => {
        dispatch(layerAction({name: null, data: null}))
    }

    const renderServiceContent = (type, sliceLocation, itemName, itemId, price) => {
        const customPrice = type==='os'?'구매하기':`${price}원`
        const estimateList = allEstimateList.estimateItems.split(',');
        let isIncludes = false;

        if(type==='os'){
            isIncludes = estimateList.some(item => serviceInstallCodes.includes(Number(item)));
        }else{
            isIncludes = estimateList.includes(`${itemId}`); //서비스가 건적에 있을경우
        }
        const pcWarning = pcInstallFlag && serviceAsCodes.includes(itemId) ? 'warning':''//출장pc설치서비스(as조립 없을때)
        const pcWarningClick = pcInstallFlag && type === 'install.visit' ? 'warningClick':''//출장pc설치서비스 선택

        const assembleWarning = assembleFlag && serviceAssembleCodes.includes(itemId) ? 'warning':''//운영체제설치서비스(조립 없을때)
        const assembleWarningClick = assembleFlag && type === 'install.os' ? 'warningClick':''//운영체제설치서비스 선택

        const osWarning = osFlag && serviceInstallCodes.includes(itemId) ? 'warning':''//운영체제설치서비스(정품운영체제 없을때)
        const osWarningClick = osFlag && type === 'os' ? 'warning':''//운영체제설치서비스 선택
        return (
            <>
                <div className={`service-name ls-05 fw-b`}>
                    <span className={`accent`}>{itemName.slice(0, sliceLocation)}</span>
                    <span>{itemName.slice(sliceLocation)}</span>
                </div>
                {isIncludes
                    ? (
                        type === 'os'
                            ?(
                                <BuyBtn
                                    className={`service-price ls-028 fw-b ${pcWarning} ${pcWarningClick} ${assembleWarning} ${assembleWarningClick} ${osWarning} ${osWarningClick}`}
                                    isIncludes={isIncludes}
                                    onClick={() => onDisplayPanel(type, itemId)}
                                ><i className={`icon-add_circle`}/> {customPrice}</BuyBtn>
                            ) : (
                                <BuyBtn
                                    className={`service-price ls-042 fw-b`}
                                    isIncludes={isIncludes}
                                    onClick={() => onConfirm(type, itemId)}
                                ><i className={`icon-remove_circle`}/> <span>서비스 취소</span></BuyBtn>
                            )
                    ) : (
                        <BuyBtn
                            className={`service-price ls-028 fw-b ${pcWarning} ${pcWarningClick} ${assembleWarning} ${assembleWarningClick} ${osWarning} ${osWarningClick}`}
                            isIncludes={isIncludes}
                            onClick={() => onDisplayPanel(type, itemId)}
                        ><i className={`icon-add_circle`}/> {customPrice}</BuyBtn>
                    )
                }
            </>
        )
    }

    const onDisplayPanel = (flag, itemId) => {
        setAssembleFlag('')
        setOsFlag('')
        setPcInstallFlag('')

        dispatch(layerAction({name:flag, data: {itemId:itemId, action:closeLayer}}))
    }

    const closeConfirm=()=>{
        dispatch(layerConfirm({name:null, data: null}))
    }

    const onConfirm = (flag, itemId) => {
        /**
         * 조립 서비스 선택
         */
        dispatch(layerConfirm({name:flag, data: {itemId:itemId, action:closeConfirm}}))
    }

    const onDeleteService = (itemId) => {
        itemAPI2.deleteService(itemId).then(res=>{
            if(res){
                const estimateItems = getCookie('item_est')
                dispatch(setEstimateItems({estimateItems}))
                dispatch(layerConfirm({name:null, data: null}))
            }
        }).catch(err=> {
            const errData = err.response.data
            layerAlert(errData.message)
            return false
        })
    }

    const setServiceAddFn = async (itemId, count, layerClose) => {
        await itemAPI2.setServicePlus(itemId, count).then(res=>{
            if(res){
                const estimateItems = getCookie('item_est')
                dispatch(setEstimateItems({ estimateItems, type: 'add', option: 'service', itemId: itemId }))
                layerClose() // 레이어 닫기 action
            }
        })
    }

    return(
        <>
            {/*조립서비스*/}
            {(layer.name==='basic' || layer.name==='premium') && (
                <AssemblyComponent
                    itemId={layer.data.itemId}
                    // itemId={10995920}
                    action={layer.data.action}
                    setServiceAddFn={setServiceAddFn}
                    layerAlert={layerAlert}
                />
            )}
            {/*정품운영체제구매*/}
            {(layer.name==='os') && (
                <OsBuyComponent
                    // itemId={1099800}
                    itemId={layer.data.itemId}
                    action={layer.data.action}
                    setServiceAddFn={setServiceAddFn}
                />
            )}
            {/*운영체제설치서비스*/}
            {(layer.name==='install.os') && (
                <OsInstallComponent
                    // itemId={1099814}
                    itemId={layer.data.itemId}
                    action={layer.data.action}
                    setServiceAddFn={setServiceAddFn}
                    setAssembleFlag={setAssembleFlag}
                    setOsFlag={setOsFlag}
                />
            )}
            {/*출장pc설치서비스*/}
            {(layer.name==='install.visit') && (
                <PcInstallComponent
                    // itemId={11653042}
                    itemId={layer.data.itemId}
                    action={layer.data.action}
                    setServiceAddFn={setServiceAddFn}
                    setPcInstallFlag={setPcInstallFlag}
                />
            )}
            {layer.confirm.name !== null && (
                <DefaultTwoButtonLayer
                    title={<span>이 서비스를 <b>취소</b> 하시겠습니까?</span>}
                    onClickLeft={closeConfirm}
                    leftButtonText="취소"
                    onClickRight={() => onDeleteService(layer.confirm.data.itemId)}
                    rightButtonText="확인"
                />
            )}
            <Wrap>
                {!init
                    ?(
                        <Loading cdnimg={process.env.REACT_APP_CDN_IMG}/>
                    ):(
                        <ServiceBox className={'serviceBox'}>
                            <BasicService>
                                <div className={`service-items`}>
                                    <div className={'service-label'}>기본 조립 서비스</div>
                                    {serviceItems.basic!==null && serviceItems.basic.map(v => {
                                        const itemName = v.itemName || '';
                                        const price = numberFormat(v.price)||0;
                                        const itemId = v.itemId;
                                        return (
                                            <ServiceItem color={'#418ded'}>
                                                {itemName?(
                                                    renderServiceContent('basic', 5, itemName, itemId, price)
                                                ) : (
                                                    <div className={`service-name`}>
                                                        <span>-</span>
                                                    </div>
                                                )}
                                            </ServiceItem>
                                        )
                                    })}
                                </div>
                            </BasicService>
                            <PremiumService>
                                <div className={`service-items`}>
                                    <div className={'service-label'}>프리미엄 조립 서비스 (수랭 쿨러, 서버)</div>
                                    {serviceItems.premium !== null && serviceItems.premium.map(v => {
                                        const itemName = v.itemName || '';
                                        const price = numberFormat(v.price) || 0;
                                        const itemId = v.itemId;
                                        return (
                                            <ServiceItem color={'#ff0000'}>
                                                {itemName ? (
                                                    renderServiceContent('premium', 7, itemName, itemId, price)
                                                ) : (
                                                    <div className={`service-name`}>
                                                        <span>-</span>
                                                    </div>
                                                )}
                                            </ServiceItem>
                                        )
                                    })}
                                </div>
                            </PremiumService>
                            <InstallService>
                                <div className={`service-items`}>
                                    <div className={'service-label'}>정품 설치 서비스</div>
                                    {serviceItems.install !== null && serviceItems.install.map(v => {
                                        const itemName = v.itemName || '';
                                        const price = numberFormat(v.price) || 0;
                                        const itemId = v.itemId;
                                        const type = v.type;
                                        return (
                                            <ServiceItem color={'#ff0000'}>
                                                {itemName ? (
                                                    renderServiceContent(type, 0, itemName, itemId, price)
                                                ) : (
                                                    <div className={`service-name`}>
                                                        <span>-</span>
                                                    </div>
                                                )}
                                            </ServiceItem>
                                        )
                                    })}
                                    {(assembleFlag || osFlag || pcInstallFlag) && (
                                        <WarningBox>
                                            {assembleFlag && (
                                                <span>
                                                    {assembleFlag}
                                                </span>
                                            )}
                                            {osFlag && (
                                                <span>
                                                    {osFlag}
                                                </span>
                                            )}
                                            {pcInstallFlag && (
                                                <span>
                                                    {pcInstallFlag}
                                                </span>
                                            )}
                                        </WarningBox>
                                    )}
                                </div>
                            </InstallService>
                        </ServiceBox>
                    )
                }
                <GuideAndPowerSeller/>
            </Wrap>
        </>
    )
}
export default React.memo(ServiceComponent)

const Loading = styled.div`
    display: flex;
    width: 950px;
    height: 138px;
    align-items: center;
    justify-content: center;
    background: ${(props) =>
    `rgba(255,255,255,0.6) url(${props.cdnimg}/img_static/img_pres/_v5/happy_loading_5.gif) no-repeat center`};
    background-size: 60px 69px;
`

const Wrap = styled.div`
    border-top: 2px solid #333;
    padding: 10px 0;

    .ls-03 { letter-spacing: -0.3px; }
    .ls-05 { letter-spacing: -0.5px; }
    .ls-028 { letter-spacing: -0.28px; }
    .ls-042 { letter-spacing: -0.42px; }
    .fw-b { font-weight: bold; }

    *:not(i) {
        font-family: 'Noto Sans KR', sans-serif !important;
        //font-weight: 500;
    }
`

const ServiceBox = styled.div`
    margin-bottom:20px;
    display: flex;

    & > div {
        width:33.3%;
        .service-items {
            padding: 0 10px;
        }
    }

    .service-label{
        font-size:16px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom:8px;
    }
`
const BasicService=styled.div`
    .service-items{ border-right: 1px solid #e8e7ea; }

`
const PremiumService=styled.div`
    .service-items{ border-right: 1px solid #e8e7ea; }
`
const InstallService=styled.div`
`
const ServiceItem=styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
    &:not(:last-child){margin-bottom: 5px;}

    .service-name{
        span{
            color: #666666;
            line-height: 24px;
        }
        .accent{
            ${(props)=>props.color && `color:${props.color}`};
        }
    }
`

const BuyBtn=styled.button`
    width:91px;
    height:22px;
    border:1px solid #CCCCCC !important;
    padding:0 6px 0 6px;
    white-space: nowrap;

    display:flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box !important;
    i{
        color: #CCCCCC;
        font-size:18px;
        margin-right:4px;
        top:1px;
    }
    &.warning{
        background: red !important;
        color:#fff !important;
        i{ color:#fff !important; }
    }
    &.warningClick{
        border-color:red !important;
    }
    &:hover{
        border-color: #418DED !important;
        background: #fff !important;
        color:#000000 !important;
        i{ color: #418DED !important; }
    }

    /*서비스가 건적에 있을경우*/
    ${props => props.isIncludes && css`
        color: #ffffff;
        background: #418DED !important;
        i{ color: #fff; }

        &:hover {
            color: #000000;
            background: #ffffff !important;
            i{ color: #418DED; }
        }
    `}


`

const WarningBox = styled.div`
    margin:10px 0 0 0;
    color: #f34522;
    line-height: 1.4;
    span{ display: block; }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/serviceComponent.js